module.exports = __webpack_public_path__ + "static/media/message-background.8d8ac16e.png";